/* eslint-disable complexity */
import { Pickable } from '@app/engine/core/interfaces';
import { html } from '@app/engine/utils/development/formatter';
import { SpaceObjectType } from '@ootk/src/main';
import { CameraType } from '../../camera/camera';
import { ColorScheme } from './color-scheme';
import { ServiceLocator } from '@app/engine/core/service-locator';
export class CountryColorScheme extends ColorScheme {
    label = 'Country';
    id = 'CountryColorScheme';
    static id = 'CountryColorScheme';
    static uniqueObjectTypeFlags = {
        countryUS: true,
        countryPRC: true,
        countryCIS: true,
        countryOther: true,
    };
    static uniqueColorTheme = {
        countryUS: [0.0, 0.0, 1.0, 1.0],
        countryPRC: [0.0, 0.0, 1.0, 1.0],
        countryCIS: [0.0, 0.0, 1.0, 1.0],
        countryOther: [0.0, 0.0, 1.0, 1.0],
    };
    constructor() {
        super(CountryColorScheme.uniqueColorTheme);
        this.objectTypeFlags = {
            ...this.objectTypeFlags, ...CountryColorScheme.uniqueObjectTypeFlags,
        };
    }
    update(obj) {
        if (ServiceLocator.getMainCamera().cameraType === CameraType.PLANETARIUM) {
            return {
                color: this.colorTheme.deselected,
                pickable: Pickable.No,
            };
        }
        const checkFacility = this.checkFacility_(obj);
        if (checkFacility) {
            return checkFacility;
        }
        if (obj.type === SpaceObjectType.PAYLOAD) {
            if (!settingsManager.isShowPayloads) {
                return {
                    color: this.colorTheme.deselected,
                    pickable: Pickable.No,
                };
            }
        }
        else if (obj.type === SpaceObjectType.ROCKET_BODY) {
            if (!settingsManager.isShowRocketBodies) {
                return {
                    color: this.colorTheme.deselected,
                    pickable: Pickable.No,
                };
            }
        }
        else if (obj.type === SpaceObjectType.DEBRIS) {
            if (!settingsManager.isShowDebris) {
                return {
                    color: this.colorTheme.deselected,
                    pickable: Pickable.No,
                };
            }
        }
        return this.checkCountry_(obj);
    }
    updateGroup(obj) {
        if (ServiceLocator.getMainCamera().cameraType === CameraType.PLANETARIUM) {
            return {
                color: this.colorTheme.deselected,
                pickable: Pickable.No,
            };
        }
        if (ServiceLocator.getGroupsManager().selectedGroup?.hasObject(obj.id)) {
            return this.checkCountry_(obj);
        }
        if (obj.isMarker()) {
            return this.getMarkerColor_();
        }
        return {
            color: this.colorTheme.deselected,
            pickable: Pickable.No,
        };
    }
    checkCountry_(obj) {
        if (!obj.isSatellite()) {
            return {
                color: this.colorTheme.deselected,
                pickable: Pickable.No,
            };
        }
        const sat = obj;
        switch (sat.country) {
            case 'United States of America':
            case 'United States':
            case 'USA':
            case 'US':
                if (this.objectTypeFlags.countryUS === false) {
                    return {
                        color: this.colorTheme.deselected,
                        pickable: Pickable.No,
                    };
                }
                return {
                    color: this.colorTheme.countryUS,
                    pickable: Pickable.Yes,
                };
            case 'Russian Federation':
            case 'CIS':
            case 'RU':
            case 'SU':
            case 'Russia':
                if (this.objectTypeFlags.countryCIS === false) {
                    return {
                        color: this.colorTheme.deselected,
                        pickable: Pickable.No,
                    };
                }
                return {
                    color: this.colorTheme.countryCIS,
                    pickable: Pickable.Yes,
                };
            case 'China':
            case 'China, People\'s Reof':
            case 'Hong Kong Special Administrative Region, China':
            case 'China (Republic)':
            case 'PRC':
            case 'CN':
                if (this.objectTypeFlags.countryPRC === false) {
                    return {
                        color: this.colorTheme.deselected,
                        pickable: Pickable.No,
                    };
                }
                return {
                    color: this.colorTheme.countryPRC,
                    pickable: Pickable.Yes,
                };
            default:
                if (this.objectTypeFlags.countryOther === false) {
                    return {
                        color: this.colorTheme.deselected,
                        pickable: Pickable.No,
                    };
                }
                return {
                    color: this.colorTheme.countryOther,
                    pickable: Pickable.Yes,
                };
        }
    }
    static layersHtml = html `
  <ul id="layers-list-countries">
    <li>
      <div class="Square-Box layers-countryUS-box"></div>
      United States
    </li>
    <li>
      <div class="Square-Box layers-countryCIS-box"></div>
      Russia
    </li>
    <li>
      <div class="Square-Box layers-countryPRC-box"></div>
      China
    </li>
    <li>
      <div class="Square-Box layers-countryOther-box"></div>
      Other
    </li>
    <li>
      <div class="Square-Box layers-facility-box"></div>
      Launch Site
    </li>
  </ul>
  `.trim();
}
